import { Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CalendarEvent } from 'angular-calendar';
import { BehaviorSubject, ReplaySubject } from 'rxjs';
import { ApiService } from './api.service';
// import { ModalComponent } from '../components/modal/modal.component';

@Injectable()
export class CalendarService {

    public day_abbr_names = [ "Sun", "Mon",  "Tue",  "Wed",  "Thu",  "Fri",  "Sat" ];
    public day_names = [ "Sunday", "Monday",  "Tuesday",  "Wednesday",  "Thursday",  "Friday",  "Saturday" ];
    public month_abbr_names = [ "Jan",  "Feb",  "Mar",  "Apr",  "May",  "Jun",  "Jul",  "Aug",  "Sep",  "Oct",  "Nov",  "Dec" ];
    public month_names = [ "January",  "February",  "March",  "April",  "May",  "June",  "July",  "August",  "September",  "October",  "November",  "December" ];

    constructor(
        public apiService:ApiService
    ) { }

    meeting_color: any = {
        primary: '#ad2121',
        secondary: '#FAE3E3',
    }

    call_color: any = {
        primary: '#1e90ff',
        secondary: '#D1E8FF',
    }

    task_color: any = {
        primary: '#e3bc08',
        secondary: '#FDF1BA',
    }

    // events: CalendarEvent[] = [
    //     {
    //         start: subDays(startOfDay(new Date()), 1),
    //         end: addDays(new Date(), 1),
    //         title: 'A 3 day event',
    //         color: this.Colors.red,
    //         actions: this.actions,
    //         allDay: true,
    //         resizable: {
    //             beforeStart: true,
    //             afterEnd: true,
    //         },
    //         draggable: true,
    //     },
    //     {
    //         start: startOfDay(new Date()),
    //         title: 'An event with no end date',
    //         color: this.Colors.yellow,
    //         actions: this.actions,
    //     },
    //     {
    //         start: subDays(endOfMonth(new Date()), 3),
    //         end: addDays(endOfMonth(new Date()), 3),
    //         title: 'A long event that spans 2 months',
    //         color: this.Colors.blue,
    //         allDay: true,
    //     },
    //     {
    //         start: addHours(startOfDay(new Date()), 2),
    //         end: addHours(new Date(), 2),
    //         title: 'A draggable and resizable event',
    //         color: this.Colors.yellow,
    //         actions: this.actions,
    //         resizable: {
    //             beforeStart: true,
    //             afterEnd: true,
    //         },
    //         draggable: true,
    //     },
    // ];

    getDateText(date:Date, format:string) {
        if (date <= new Date('1900-01-01')) return '';

        var yyyy = date.getFullYear();
        var M = date.getMonth() + 1;
        var d = date.getDate();
        var H = date.getHours();
        var m = date.getMinutes();
        var s = date.getSeconds();
        var dd = (d < 10 ? '0' : '') + d.toString();
        var MM = (M < 10 ? '0' : '') + M.toString();
        var DDDD = this.getDayName(date.getDay());
        var DDD = this.getAbbrDayName(date.getDay());
        var MMM = this.getAbbrMonthName(M - 1);
        var MMMM = this.getMonthName(M - 1);
        var HH = (H < 10 ? '0' : '') + H.toString();
        var h = H > 12 ? H - 12 : H;
        var hh = (h < 10 ? '0' : '') + h.toString();
        var mm = (m < 10 ? '0' : '') + m.toString();
        var ss = (s < 10 ? '0' : '') + s.toString();
        var tt = H >= 12 ? 'PM' : 'AM';
        var has_tt = format.indexOf('tt') >= 0;
        if (has_tt && hh == '00') hh = '12';  // ie. convert 00:25 AM to 12:25 AM

        var format_values:any[] = [];
        if (format.indexOf('yyyy') >= 0) format_values.push({format: 'yyyy', value: yyyy.toString()});
        if (format.indexOf('MMMM') >= 0) format_values.push({format: 'MMMM', value: MMMM.toString()});
        if (format.indexOf('MMMM') < 0 && format.indexOf('MMM') >= 0) format_values.push({format: 'MMM', value: MMM.toString()});
        if (format.indexOf('MMMM') < 0 && format.indexOf('MMM') < 0 && format.indexOf('MM') >= 0) format_values.push({format: 'MM', value: MM.toString()});
        if (format.indexOf('dd') >= 0) format_values.push({format: 'dd', value: dd.toString()});
        if (format.indexOf('dd') < 0 && format.indexOf('d') >= 0) format_values.push({format: 'd', value: d.toString()});
        if (format.indexOf('HH') >= 0) format_values.push({format: 'HH', value: HH.toString()});
        if (format.indexOf('HH') < 0 && format.indexOf('H') >= 0) format_values.push({format: 'H', value: H.toString()});
        if (format.indexOf('hh') >= 0) format_values.push({format: 'hh', value: hh.toString()});
        if (format.indexOf('hh') < 0 && format.indexOf('h') >= 0) format_values.push({format: 'h', value: h.toString()});
        if (format.indexOf('mm') >= 0) format_values.push({format: 'mm', value: mm.toString()});
        if (format.indexOf('mm') < 0 && format.indexOf('m') >= 0) format_values.push({format: 'mm', value: m.toString()});
        if (format.indexOf('ss') >= 0) format_values.push({format: 'ss', value: ss.toString()});
        if (format.indexOf('ss') < 0 && format.indexOf('s') >= 0) format_values.push({format: 's', value: s.toString()});
        if (format.indexOf('tt') >= 0) format_values.push({format: 'tt', value: tt.toString()});
        if (format.indexOf('DDDD') >= 0) format_values.push({format: 'DDDD', value: DDDD.toString()});
        if (format.indexOf('DDDD') < 0 && format.indexOf('DDD') >= 0) format_values.push({format: 'DDD', value: DDD.toString()});

        var date_text = format;
        format_values.forEach(fv => {
            date_text = date_text.replace(fv.format, fv.value);
        })

        // var date_text = format.replace('yyyy', yyyy.toString())
        //                       .replace('MMMM', MMMM).replace('MMM', MMM.toString())
        //                       .replace('MM', MM).replace('M', m.toString())
        //                       .replace('dd', dd).replace('d', d.toString())
        //                       .replace('HH', HH).replace('H', H.toString())
        //                       .replace('hh', hh).replace('h', h.toString())
        //                       .replace('mm', mm).replace('m', m.toString())
        //                       .replace('ss', ss).replace('s', s.toString())
        //                       .replace('tt', tt)
        //                       .replace('DDDD', DDDD).replace('DDD', DDD.toString())             // day replace must happen last to post replacement
        return date_text;
    }

    getPostfixDate(date) {
        var postfix = "'th";
        switch (date) {
            case 1: postfix = "'st"; break;
            case 2: postfix = "'nd"; break;
            case 3: postfix = "'rd"; break;
            case 21: postfix = "'st"; break;
        }        
        return date + postfix;
    }
 
    getTodaysDate(bincludeYear:boolean = true, bUsePostfixDate:boolean = false, bIncludeDayOfWeek: boolean = false) {
		var today = new Date();
		var month = this.getAbbrMonthName(today.getMonth());
        var date_string = bUsePostfixDate ? this.getPostfixDate(today.getDate()) : today.getDate();
        var year_string = bincludeYear ? today.getFullYear() : "";
        var day_of_week = bIncludeDayOfWeek ? this.day_names[today.getDay()] : "";
		return `${day_of_week} ${month} ${date_string} ${year_string}`.trim();
	}

    getAbbrMonthName(month:number) {
        return this.month_abbr_names[month];
    }

    getMonthName(month:number) {
        return this.month_names[month];
    }

    getAbbrDayName(date:number) {
        return this.day_abbr_names[date];
    }

    getDayName(date:number) {
        return this.day_names[date];
    }

    // month is 0 based
    getDaysInMonth(year:number, month:number) {
        return (new Date(year, month + 1, 0).getDate());
    }

    generateCalendarEvents(events:Array<any>) {
        let calendarEvents:CalendarEvent[];
        events.forEach(e => {
            calendarEvents.push({
                start: new Date(e.date),
                end: new Date(e.date),
                title: e.subject,
                color: this.meeting_color
            });
        });

        return calendarEvents;
    }

    updateCalendarEvents(searchParams:any) {
        this.apiService.getModelData("meetings", searchParams).subscribe(
            result => {
            },
            err => {
                console.log(err);
            }
        );

        this.apiService.getModelData("calls", searchParams).subscribe(
            result => {
            },
            err => {
                console.log(err);
            }
        );
    }

    getLocalDateFromGMTString(gmt_str:string): Date {
        var date_str = gmt_str.substring(0, 10);
        var hour = parseInt(gmt_str.substring(11, 13));
        var mm = gmt_str.substring(14, 16)
        var ss = gmt_str.substring(17, 19)
        var tt = gmt_str.substring(20, 22);
        hour = (tt == 'PM') ? hour + 12 : hour;
        var HH = (hour < 10 ? '0': '') + hour.toString();
        var iso_str = `${date_str} ${HH}:${mm}:${ss}.000Z`;
        return new Date(iso_str);
    }
}


// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/services/calendar.service.ts